import { Grid, IconButton, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Add,
  Chip,
  Connector,
  Connector1,
  KpiCard,
  MultiProgressBarCard,
  NoDataVisual,
  PageTitleAndSubTitle,
  SummaryCard,
  Trend,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useEffect, useState } from 'react';
import DeepDiveConstants from '../../core-utils/messages/DeepDiveConstants';
import Typography from '@HomaHealth/ui-component-library/lib/_patient-access-components/atoms/Typography';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import DateFilter from '../../_components/molecules/DateFilter';
import { useStores } from '../../stores';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import Loader from '../../_components/molecules/Loader';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { numberToCurrencyFormatter } from '../../core-utils/helper-utils/helper';
import { getTextWithToolTip } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import DeepDiveCostTrendModal from '../../_components/organisms/DeepDiveCostTrendModal';
import AddActivityModal from '../../_components/organisms/AddActivityModal';
import { observer } from 'mobx-react';
import DeepDiveCategoryPopUp from '../../_components/organisms/DeepDiveCategoryPopUp';
import ClaimDetailsModal from '../../_components/organisms/ClaimDetailsModal';
import { useLocation } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import { getDeepDiveFilteredMembers } from '../../core-utils/axios/Cohort/DeepDive';

interface topCardData {
  currentCost: string;
  previousCost: string;
  diffPercentage: string;
}

export interface DeepDiveResultItem {
  total_paid_amount: number | string;
  percent?: number;
  memberList?: any[];
  claimsList?: any[];
  value: string | number;
  selected?: boolean;
}
export type TopCardColorKeys = keyof typeof DeepDiveConstants.TOP_CARD_COLORS;
export interface DeepDiveEntry {
  identifier: TopCardColorKeys;
  claimsList: any[];
  result: DeepDiveResultItem[];
}
interface LocationProps {
  state?: {
    key?: any;
    value?: any;
  };
}

type DeepDiveData = Record<string, DeepDiveEntry>;

const DeepDivePage = observer(() => {
  //Constants
  const { classes } = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 5px',
      width: '1230px',
    },
    title: {
      marginBottom: '36px',
      position: 'relative',
      marginLeft: '58px',
    },
    content: {
      borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      width: '100%',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      backgroundColor: patientAccessTheme.palette.status.white,
    },
    innerContainer: {
      backgroundColor: patientAccessTheme.palette.grey[100],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '7px',
      height: '40px',
    },
    cards: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '30px',
    },
    topCards: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    tooltip: {
      backgroundColor: patientAccessTheme.palette.grey[900],
      padding: '10px',
      fontSize: '13px',
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '16px',
      marginTop: '2px',
      color: patientAccessTheme.palette.status.white,
    },
    arrow: {
      color: patientAccessTheme.palette.grey[900],
      marginLeft: '50px',
    },
    popper: {
      marginTop: '-4px',
      marginLeft: '-34px',
    },
  })();

  const location: LocationProps = useLocation();
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const employerGroupStore = useStores().employerGroupStore;
  const loginPageStore = useStores().loginPageStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
    noDateFilter,
  } = quaterlyReportStore;
  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  //States
  const [loading, setLoading] = useState<boolean>(false);
  const [topCardData, setTopCardData] = useState<topCardData>({
    currentCost: '',
    previousCost: '',
    diffPercentage: '',
  });
  const [deepDiveData, setDeepDiveData] = useState<DeepDiveData>({});
  const [selectedDeepDiveEntries, setSelectedDeepDiveEntries] = useState<
    DeepDiveEntry[]
  >([]);

  const [costTrendModalOpen, setCostTrendModalOpen] = useState<boolean>(false);
  const [selectedTrend, setSelectedTrend] = useState<DeepDiveResultItem | null>(
    null,
  );
  const [selectedIdentifier, setSelectedIdentifier] = useState<string>('');
  const [addTaskModalOpen, setAddTaskModalOpen] = useState<boolean>(false);

  const [categoryPopUpOpen, setCategoryPopUpOpen] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<any>();

  const [claimDetailsPopUpOpen, setClaimDetailsPopUpOpen] = useState<boolean>(
    false,
  );
  const [selectedClaim, setSelectedClaim] = useState<any>();
  const [key] = useState(location.state?.key ?? undefined);
  const value = location.state?.value;
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  //Functions
  const handleItemClick = (
    label: any,
    clickedValue: any,
    isInternal?: boolean,
    selectedResultItem?: any,
  ) => {
    const entry = deepDiveData[label];
    if (!entry) {
      return;
    }
    let updatedResult;

    if (isInternal && selectedResultItem) {
      updatedResult = [
        {
          ...selectedResultItem,
          selected: true,
        },
      ];
    } else {
      updatedResult = entry.result.map((item) =>
        item.value === clickedValue ? { ...item, selected: true } : item,
      );
    }

    const updatedEntry: DeepDiveEntry = {
      ...entry,
      result: updatedResult,
    };
    const selectedEntry = entry.result.find(
      (temp: any) => temp.value === clickedValue,
    );
    if (label === 'Claims') {
      setSelectedClaim({
        claimId: clickedValue,
        memberId: selectedEntry?.memberList?.[0],
      });
      setClaimDetailsPopUpOpen(true);
    } else {
      setSelectedDeepDiveEntries((prev) => [...prev, updatedEntry]);
      getAllCharts(entry.identifier, clickedValue, selectedEntry?.claimsList);
    }
  };

  const handleTopCardClick = (identifier: string, index?: number) => {
    if (identifier === 'Total Cost' || index === undefined) {
      setSelectedDeepDiveEntries([]);
      getAllCharts();
    } else {
      const entry = selectedDeepDiveEntries[index];
      const selectedEntry = entry.result.find(
        (temp: any) => temp.selected === true,
      );
      setSelectedDeepDiveEntries(selectedDeepDiveEntries.slice(0, index + 1));
      getAllCharts(
        entry.identifier,
        selectedEntry?.value,
        selectedEntry?.claimsList,
        undefined,
      );
    }
  };

  const handleTrendClick = (identifier: string, item: any) => {
    setSelectedTrend(item);
    setSelectedIdentifier(identifier);
    setCostTrendModalOpen(true);
  };

  const handleCategoryClick = (
    identifier: string,
    label: any,
    claim_id_list: any,
  ) => {
    setSelectedCategory({ value: label, identifier, claim_id_list });
    setCategoryPopUpOpen(true);
  };

  const chunkDeepDiveEntries = (entries: any) => {
    const total = entries.length;
    const result = [];
    if (total < 5) {
      // Show all in first row
      result.push(entries);
    } else if (total === 5) {
      // Special case: first row gets 3, rest goes to second row
      result.push(entries.slice(0, 3));
      result.push(entries.slice(3));
    } else {
      // More than 5: first row gets 4, rest are in groups of 5
      result.push(entries.slice(0, 4));
      let remaining = entries.slice(4);
      while (remaining.length) {
        result.push(remaining.slice(0, 5));
        remaining = remaining.slice(5);
      }
    }
    return result;
  };
  const {
    totalResults,
    memberIds: cohortMembers,
    isInitializing,
  } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getDeepDiveFilteredMembers(payload, undefined, value, key),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    isInternal: true,
  });

  //Apis Calls
  const getAllCharts = async (
    identifier?: string,
    value?: any,
    claim_id_list?: any,
    key?: any,
  ) => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        getDeepDiveData(identifier, value, claim_id_list, key),
      ])
        .then(() => {
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        }));
  };

  const getDeepDiveData = async (
    identifier?: string,
    value?: any,
    claim_id_list?: any,
    key?: any,
  ) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.deepDiveBaseUrl +
          properties.filterData,
        {
          ...payload,
          selectedCategory: {
            identifier,
            value,
            key,
          },
          claim_id_list,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
        },
        { signal: abortController.signal },
      )
      .then(async (res) => {
        if (res?.status === 200) {
          const deepDiveData = res?.data?.data;
          const topCard: topCardData = {
            currentCost: numberToCurrencyFormatter(
              deepDiveData?.currentTotalPaid,
              true,
              2,
            ),
            previousCost: numberToCurrencyFormatter(
              deepDiveData?.previousTotalPaid,
              true,
              2,
            ),
            diffPercentage: deepDiveData?.percentageDifference,
          };
          setTopCardData(topCard);
          deepDiveData?.parentData?.length > 0
            ? setSelectedDeepDiveEntries(
                deepDiveData?.parentData.filter(
                  (temp: any) => temp.result.length > 0,
                ),
              )
            : '';
          setDeepDiveData(deepDiveData?.deepDiveData ?? {});
        }
      })
      .catch((ex) => {
        handleOpenSnackBar('Something went wrong', 'error', 3000);
        return ex;
      });
  };
  const handleAddTask = async (data: any) => {
    await axios.post(
      properties.aiqBaseUrl +
        properties.riskRegisterBaseUrl +
        properties.addActivity,
      {
        ...data,
        eg_nid: payload.eg_nid[0],
      },
    );
    handleOpenSnackBar('Task has been added successfully', 'success', 6000);
    setAddTaskModalOpen(false);
  };

  //UseEffects
  useEffect(() => {
    if (isInitializing) {
      return;
    }
    getAllCharts(undefined, value, undefined, key);
    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    noDateFilter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);
  const groupedDeepDiveEntries = chunkDeepDiveEntries(selectedDeepDiveEntries);

  return (
    <>
      {isPlanDatesLoading || loading || isInitializing ? (
        <Loader />
      ) : (
        <Grid container className={classes.root}>
          <Grid className={classes.title}>
            <PageTitleAndSubTitle
              title={DeepDiveConstants.TITLE}
              chip={
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <Typography
                    fontSize="17px"
                    lineHeight="21px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    fontType="semiBold"
                    margin="0px 8px 0px 0px"
                  >
                    for
                  </Typography>
                  <DateFilter showNoDateFilterOption={true} />
                  {noDateFilter && (
                    <Tooltip
                      arrow
                      classes={{
                        tooltip: classes.tooltip,
                        arrow: classes.arrow,
                        popper: classes.popper,
                      }}
                      title={DeepDiveConstants.NO_DATE_FILTER}
                      placement="bottom-start"
                    >
                      <InfoOutlinedIcon
                        style={{
                          height: '16px',
                          width: '16px',
                          marginLeft: '0.5rem',
                          fill: patientAccessTheme.palette.status.icon,
                        }}
                      />
                    </Tooltip>
                  )}
                </div>
              }
              subTitle={''}
              customButton
              customButtonText={DeepDiveConstants.ADD_TO_TASKBOARD}
              customButtonStartIcon={<Add />}
              customButtonWidth="180px"
              customButtonVariant={'contained'}
              customButtonClick={() => {
                setAddTaskModalOpen(true);
              }}
              showQueryDataButton={checkUserAccess(
                UserAccessConstants.COHORT_DETAILS,
                loginPageStore.userResponse.role.name,
                loginPageStore.userFeatures,
              )}
              queryButtonText={
                cohortDetailsStore.cohortDetailsList?.length > 0 &&
                cohortDetailsStore.cohortDetailsList[0].category !== ''
                  ? 'Edit Cohort'
                  : 'Add Cohort'
              }
              queryDataAction={() => {
                if (
                  checkUserAccess(
                    UserAccessConstants.COHORT_DETAILS,
                    loginPageStore.userResponse.role.name,
                    loginPageStore.userFeatures,
                  )
                ) {
                  openModal();
                }
              }}
            />
          </Grid>
          <Grid className={classes.content}>
            {Object.entries(deepDiveData).length > 0 ? (
              <>
                <Grid style={{ width: '1230px' }}>
                  <CohortFilterBar />
                </Grid>
                {selectedDeepDiveEntries?.length > 0 ? (
                  <Grid className={classes.topCards}>
                    <Chip
                      label={
                        <Grid style={{ display: 'flex', gap: '8px' }}>
                          <Typography
                            fontSize="14px"
                            lineHeight="24px"
                            fontType="medium"
                            textColor={
                              patientAccessTheme.palette.text.mediumemphasis
                            }
                          >
                            {DeepDiveConstants.TOTAL_COST}
                          </Typography>
                          <Typography
                            fontSize="18px"
                            fontType="semiBold"
                            textColor={patientAccessTheme.palette.grey[900]}
                          >
                            {topCardData.currentCost}
                          </Typography>
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleTrendClick('Total Cost', {
                                value: 'Total',
                                total_paid_amount: topCardData?.currentCost,
                              });
                            }}
                            size="small"
                          >
                            <Trend
                              stroke={patientAccessTheme.palette.grey[500]}
                              color={'#4D648B'}
                              fill="white"
                            />
                          </IconButton>
                        </Grid>
                      }
                      backgroundColor={patientAccessTheme.palette.status.white}
                      border={`1px solid ${patientAccessTheme.palette.grey[300]}`}
                      borderRadius="8px"
                      padding="5px 8px"
                      height="48px"
                      width={'fit-content'}
                      onClick={() => handleTopCardClick('Total Cost')}
                    />

                    {groupedDeepDiveEntries.map((group, rowIndex) => (
                      <div
                        key={rowIndex}
                        className={classes.topCards}
                        style={{
                          marginTop: rowIndex === 0 ? 0 : '18px',
                        }}
                      >
                        {group.map((entry: any, index: number) => {
                          const selectedItem = entry?.result?.find(
                             
                            (item: any) => item?.selected,
                          );
                          const { headerBg, bg } =
                            DeepDiveConstants.TOP_CARD_COLORS[
                              entry.identifier as TopCardColorKeys
                            ] || DeepDiveConstants.TOP_CARD_COLORS['default'];

                          const isLastInGroup = index === group.length - 1;
                          const isDataAvailable = entry?.result?.length > 1;
                          return isLastInGroup &&
                            rowIndex === groupedDeepDiveEntries.length - 1 ? (
                            <>
                              <div style={{ position: 'relative' }}>
                                {isDataAvailable ? (
                                  <Connector
                                    style={{
                                      position: 'absolute',
                                      top: '-47px',
                                    }}
                                  />
                                ) : (
                                  <Connector1
                                    style={{
                                      position: 'absolute',
                                      top: '-8px',
                                    }}
                                  />
                                )}
                              </div>
                              <KpiCard
                                key={entry.identifier}
                                title={selectedItem?.value.toString() ?? ''}
                                percent={`${
                                  selectedItem?.percent?.toFixed(2) ?? '0'
                                }%`}
                                cost={numberToCurrencyFormatter(
                                  selectedItem?.total_paid_amount ?? 0,
                                  true,
                                  2,
                                )}
                                data={entry.result
                                   
                                  .filter((item: any) => !item.selected)
                                   
                                  .map((item: any) => ({
                                    name: item?.value.toString() || '',
                                    percent: `${
                                      item?.percent?.toFixed(2) ?? '0'
                                    }%`,
                                    cost:
                                      numberToCurrencyFormatter(
                                        item?.total_paid_amount,
                                        true,
                                        2,
                                      ) || '$0',
                                  }))}
                                visibleLength={20}
                                headerStyles={{ backgroundColor: headerBg }}
                                bodyStyles={{
                                  backgroundColor: bg,
                                  height: '84px',
                                }}
                                mainGridStyles={{
                                  marginLeft: '36px',
                                  width: '320px',
                                  height: isDataAvailable ? '' : '48px',
                                }}
                                handleTrendClick={() =>
                                  handleTrendClick(
                                    entry.identifier,
                                    selectedItem,
                                  )
                                }
                              />
                            </>
                          ) : (
                            <>
                              <div style={{ position: 'relative' }}>
                                <Connector1
                                  style={{
                                    position: 'absolute',
                                    top: '-8px',
                                  }}
                                />
                              </div>
                              <Chip
                                key={entry.identifier}
                                label={
                                  <Grid style={{ display: 'flex', gap: '8px' }}>
                                    <Typography
                                      fontSize="14px"
                                      lineHeight="24px"
                                      fontType="medium"
                                      textColor={
                                        patientAccessTheme.palette.text
                                          .mediumemphasis
                                      }
                                    >
                                      {getTextWithToolTip(
                                        selectedItem?.value.toString() ?? '',
                                        8,
                                      )}
                                    </Typography>
                                    <Typography
                                      fontSize="18px"
                                      fontType="semiBold"
                                      textColor={
                                        patientAccessTheme.palette.grey[900]
                                      }
                                    >
                                      {numberToCurrencyFormatter(
                                        selectedItem?.total_paid_amount ?? 0,
                                        true,
                                        2,
                                      )}
                                    </Typography>
                                    <IconButton
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleTrendClick?.(
                                          entry.identifier,
                                          selectedItem,
                                        );
                                      }}
                                      size="small"
                                    >
                                      <Trend
                                        stroke={
                                          patientAccessTheme.palette.grey[500]
                                        }
                                        color={'#4D648B'}
                                        fill="white"
                                      />
                                    </IconButton>
                                  </Grid>
                                }
                                backgroundColor={
                                  patientAccessTheme.palette.status.white
                                }
                                border={`1px solid ${patientAccessTheme.palette.grey[300]}`}
                                borderRadius="8px"
                                padding="5px 8px"
                                height="48px"
                                width="fit-content"
                                onClick={() =>
                                  handleTopCardClick(entry.identifier, index)
                                }
                                styleProps={{ marginLeft: '36px' }}
                              />
                            </>
                          );
                        })}
                      </div>
                    ))}
                  </Grid>
                ) : (
                  <SummaryCard
                    title={DeepDiveConstants.TOTAL_COST}
                    currentValue={topCardData?.currentCost}
                    previousValue={topCardData?.previousCost}
                    changePercent={topCardData?.diffPercentage ?? '-'}
                    isIncrease={!topCardData?.diffPercentage?.includes('-')}
                    onTrendClick={() => {
                      handleTrendClick('Total Cost', {
                        value: 'Total',
                        total_paid_amount: topCardData?.currentCost,
                      });
                    }}
                  />
                )}

                <Grid className={classes.innerContainer}>
                  <Typography
                    fontSize="12px"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                    fontType="medium"
                  >
                    {DeepDiveConstants.HEADER}
                  </Typography>
                  <Chip
                    label={
                      <Typography
                        fontSize="12px"
                        lineHeight="15px"
                        fontType="medium"
                        textColor={
                          patientAccessTheme.palette.text.mediumemphasis
                        }
                      >
                        {DeepDiveConstants.TOTAL_COST}
                      </Typography>
                    }
                    backgroundColor={patientAccessTheme.palette.status.white}
                    border={`1px solid ${patientAccessTheme.palette.grey[300]}`}
                    borderRadius="50px"
                    padding="5px 8px"
                    height="25px"
                    width={'100px'}
                  />
                </Grid>
                <Grid className={classes.cards}>
                  {Object.entries(deepDiveData).map(
                    ([label, { identifier, claimsList, result }]) => {
                      const { bar, headerBg, bg, textColor } =
                        DeepDiveConstants.CARD_COLORS_BY_IDENTIFIERS[
                          identifier
                        ] ||
                        DeepDiveConstants.CARD_COLORS_BY_IDENTIFIERS['default'];

                      return (
                        <MultiProgressBarCard
                          key={label}
                          mainLabel={
                            <Typography
                              fontSize="14px"
                              lineHeight="24px"
                              fontType="semiBold"
                              textColor={textColor}
                            >
                              {getTextWithToolTip(label, 40, {}, 'top-start')}
                            </Typography>
                          }
                          showTrendButton={true}
                          data={result.map((item: any) => ({
                            name: item?.value || '',
                            percent: item?.percent?.toFixed(2) || 0,
                            cost:
                              numberToCurrencyFormatter(
                                item?.total_paid_amount,
                                true,
                                2,
                              ) || '$0',
                            handleOnClick: () =>
                              handleItemClick(label, item?.value),
                            handleTrendOnClick: () =>
                              handleTrendClick(identifier, item),
                          }))}
                          mainGridStyles={{ width: '355px' }}
                          headerStyles={{ backgroundColor: headerBg }}
                          bodyStyles={{
                            backgroundColor: bg,
                            padding: '10px 8px 15px 16px',
                          }}
                          barColor={bar}
                          barBackground="#2E2F331A"
                          handleOnClick={
                            result.length > 0
                              ? () =>
                                  handleCategoryClick(
                                    identifier,
                                    label,
                                    claimsList,
                                  )
                              : undefined
                          }
                          visibleLength={20}
                        />
                      );
                    },
                  )}
                </Grid>
              </>
            ) : (
              <NoDataVisual content="No breakdown available for the selected date range." />
            )}
          </Grid>
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      {costTrendModalOpen && (
        <DeepDiveCostTrendModal
          open={costTrendModalOpen}
          setOpen={setCostTrendModalOpen}
          handleOpenSnackBar={handleOpenSnackBar}
          selectedTrend={selectedTrend}
          selectedTrendIdentifier={selectedIdentifier}
          payload={payload}
          setAddTaskModalOpen={setAddTaskModalOpen}
          isIncurredDate={isIncurredDate}
          isPaidDate={isPaidDate}
        />
      )}
      {addTaskModalOpen && (
        <AddActivityModal
          open={addTaskModalOpen}
          setOpen={setAddTaskModalOpen}
          handleSubmit={handleAddTask}
          handleOpenSnackBar={handleOpenSnackBar}
          eg_nid={payload.eg_nid[0]}
        />
      )}
      {categoryPopUpOpen && (
        <DeepDiveCategoryPopUp
          open={categoryPopUpOpen}
          setOpen={setCategoryPopUpOpen}
          handleOpenSnackBar={handleOpenSnackBar}
          selectedCategory={selectedCategory}
          payload={payload}
          handleTrendClick={handleTrendClick}
          handleItemClick={handleItemClick}
        />
      )}
      {claimDetailsPopUpOpen && (
        <ClaimDetailsModal
          open={claimDetailsPopUpOpen}
          setOpen={setClaimDetailsPopUpOpen}
          handleOpenSnackBar={handleOpenSnackBar}
          claimId={selectedClaim?.claimId}
          memberID={selectedClaim?.memberId}
        />
      )}
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={cohortMembers}
      />
    </>
  );
});

export default DeepDivePage;
